import { Box } from 'features/knowledgeDocumentViewer/components/viewer/shared/types'
import { ActionMode } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import type {
  BoundingBoxJsonItem,
  NormalizedBBox,
} from 'features/knowledgeDocumentViewer/types/ocrViewer'

export const calculateGroupBoundingBoxes = (
  boxes: BoundingBoxJsonItem[]
): NormalizedBBox => {
  const minLeft = Math.min(...boxes.map((b) => b.bounding_box.left))
  const minTop = Math.min(...boxes.map((b) => b.bounding_box.top))
  const maxRight = Math.max(
    ...boxes.map((b) => b.bounding_box.left + b.bounding_box.width)
  )
  const maxBottom = Math.max(
    ...boxes.map((b) => b.bounding_box.top + b.bounding_box.height)
  )

  const boundingBox: NormalizedBBox = {
    top: minTop,
    left: minLeft,
    width: maxRight - minLeft,
    height: maxBottom - minTop,
  }

  return boundingBox
}

export const shouldBoxBeDisabled = (box: Box, actionMode: ActionMode) => {
  return (
    (actionMode === ActionMode.Assign && box.confirmed) ||
    (actionMode === ActionMode.Remove && !box.confirmed) ||
    (actionMode === ActionMode.Group && box.confirmed) ||
    (actionMode === ActionMode.Split &&
      (box.confirmed || box.groupId === undefined))
  )
}
